import { Component, Inject, OnInit } from '@angular/core';
import { MeasureService } from '../measure.service';
import { catchError, map, switchMap } from 'rxjs/operators';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { of } from 'rxjs';

@Component({
  selector: 'app-modal-share-measure',
  templateUrl: './modal-share-measure.component.html',
  styleUrls: ['./modal-share-measure.component.scss']
})
export class ModalShareMeasureComponent implements OnInit {

  modalData: any;
  isLoading: boolean;
  shareMeasureForm: FormGroup;
  isShare: boolean = false;
  isError: boolean = false;
  errMsg: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalShareMeasureComponent>,
    private measureService: MeasureService,
    private fb: FormBuilder
  ) {
    this.modalData = data;

    this.shareMeasureForm = fb.group({
      EMAIL: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]],
      MEASURE_ID: [this.modalData.MEASURE_ID, Validators.required]
    })
  }

  ngOnInit(): void {
    // console.log(this.modalData);
  }

  send(form) {
    this.measureService.requestAccessViewByMeasure(form).pipe(
      map(res => {
        if (res.success) {
          this.isShare = true;
          this.isError = false;
          this.shareMeasureForm.get('EMAIL').setValue('');
        } else {
          this.isError = true;
          this.errMsg = res.message;
        }
      }),
      catchError(err => {
        this.isError = true;
        this.errMsg = err.error.message;
        return of(false);
      })
    ).subscribe();
  }

  closeModal() {
    const response = {
      status: false,
    }

    this.dialogRef.close(response);
  }

}
